export const config = {
  id: 'devops',
  icon: 'Settings',
  color: 'orange',
  title: 'DevOps Engineer',
  description: 'Infrastructure automation, CI/CD pipelines, and system reliability',
  department: 'Engineering',
  experienceLevels: ['junior', 'mid', 'senior'],
  operatingSystems: ['macos', 'windows', 'linux'],
  estimatedOnboardingDays: {
    junior: 8,
    mid: 6,
    senior: 4
  }
};
